import { Options, Vue } from 'vue-class-component';
import StdPageLayout from '../std-page-layout/index.vue';
@Options<NoAccess>({
  components:{
    StdPageLayout
  }
})
export default class NoAccess extends Vue {

}
